export default __webpack_public_path__ + "static/media/1973.9eebda9d.png";